function loadItems(r) {
  let a = parseInt(document.querySelector("[data-total-pages]").value, 10),
    o = parseInt(document.querySelector("[data-current-page]").value, 10);
  var e = o + 1,
    t =
      ((o += 1),
      document
        .querySelector("[data-next-url]")
        .value.replace(/page=[0-9]+/, "page=" + o));
  let l = document
    .querySelector("[data-next-url]")
    .value.replace(/page=[0-9]+/, "page=" + e);
  (document.querySelector("[data-current-page]").value = o),
    r.setAttribute("disabled", ""),
    r.classList.add("loading"),
    fetch(t)
      .then((e) => {
        if (e.ok) return e.text();
        throw new Error("Network response was not ok");
      })
      .then((e) => {
        e = new DOMParser()
          .parseFromString(e, "text/html")
          .querySelector(".load-more-grid").innerHTML;
        document
          .querySelector(".load-more-grid")
          .insertAdjacentHTML("beforeend", e),
          colorSwatches();
      })
      .catch((e) => {
        console.error("Error loading items:", e),
          r.removeAttribute("disabled"),
          r.classList.remove("loading");
      })
      .finally(() => {
        var e, t;
        o <= a &&
          ((t = document.querySelector(".infinite-scroll__data")) &&
            o !== a &&
            ((e = t.querySelector("input[data-next-url]")),
            (t = t.querySelector("input[data-current-page]")),
            e && ((e.dataset.nextUrl = l), (e.value = l)),
            t && ((t.dataset.currentPage = o), (t.value = o)),
            checkVisibility()),
          r.removeAttribute("disabled"),
          r.classList.remove("loading"),
          o === a) &&
          r.remove();
      });
}
function checkVisibility() {
  document.querySelectorAll(".js-infinite-scroll").forEach((t) => {
    let r = new IntersectionObserver((e) => {
      e.forEach((e) => {
        e.isIntersecting && (loadItems(t), r.unobserve(e.target));
      });
    });
    r.observe(t);
  });
}
function loadMore() {
  document.querySelectorAll(".js-load-more").forEach((e) => {
    e.onclick = () => {
      loadItems(e);
    };
  }),
    checkVisibility();
}
loadMore();
